import { Atom, atom } from 'src/@core/hooks/useVigoAtomStore';

export const importFormMethodsAtom: Atom<any> = atom({});

export const importMappingFormMethodsAtom: Atom<any> = atom({});
